import React from 'react';
import { Text, TextType } from 'ui-components/components/text';
import messages from './messages';

export const ShopperBulletCompareServices = () => <Text textType={TextType.H4} value={messages.shopperBulletCompareServices} />;
